module.exports = __webpack_public_path__ + "img/B6403_CyclewayVisuals_Location_03.23565ae0.jpg";